import classnames from 'classnames'
import { useEffect, useRef, useState } from 'react'

import { TEST_LOCATORS } from '@src/constants/test-locators'
import ContentfulInternationalSizeConversionGuide from '@src/quince-site-common/src/domains/contentful/contentful-international-size-conversion-guide'
import {
  ContentfulSizeChart,
  ContentfulSizeChartSection,
} from '@src/quince-site-common/src/domains/contentful/ContentfulProduct'

import { ProductSizeGuide } from '../sizeGuide/SizeGuide.types'

import SizeChartContent from './components/SizeChartContent.component'
import styles from './sizeChart.module.scss'

interface SizeChartProps {
  className?: string
  activeSizeGuideUnitIndex: number
  productSizeGuides?: ProductSizeGuide[]
  sizeChart: ContentfulSizeChart | ContentfulInternationalSizeConversionGuide | undefined
}

const SCROLL_EDGE_THRESHOLD = 2

const SizeChart = (props: SizeChartProps) => {
  const sizeChartSections: ContentfulSizeChartSection[] = props.sizeChart?.sections || []
  const activeSizeChartSection = sizeChartSections[props.activeSizeGuideUnitIndex]
  const viewportRef = useRef<HTMLDivElement>(null)
  const [canScrollRight, setCanScrollRight] = useState(false)

  useEffect(() => {
    const table = viewportRef.current?.querySelector('table')
    if (!table) return undefined

    const update = () => {
      setCanScrollRight(table.scrollLeft + table.clientWidth < table.scrollWidth - SCROLL_EDGE_THRESHOLD)
    }

    update()
    table.addEventListener('scroll', update, { passive: true })
    const resizeObserver = new ResizeObserver(update)
    resizeObserver.observe(table)

    return () => {
      table.removeEventListener('scroll', update)
      resizeObserver.disconnect()
    }
  }, [activeSizeChartSection])

  return (
    <div
      ref={viewportRef}
      className={classnames(styles.container, canScrollRight && styles.containerFadeRight)}
      data-testid={TEST_LOCATORS.SIZE_CHART}
    >
      <SizeChartContent sizeChartSection={activeSizeChartSection} />
    </div>
  )
}

export default SizeChart
